import {
  isPaid,
  getCompanyId,
  getCompanyName,
  getCompanyAddress,
  getLogoVersion,
  doesLogoExists as amalgamDoesLogoExists,
  getLogoHeight as amalgamGetLogoHeight,
  getLogoWidth as amalgamGetLogoWidth,
  getAltLogoVersion,
  doesAltLogoExists as amalgamDoesAltLogoExists
} from './Amalgam';

export const isPlatinum = () => isPaid();

export { getCompanyId, getCompanyName, getCompanyAddress };

export const getLogoPath = () =>
  doesLogoExists()
    ? `https://d1h96izmtdkx5o.cloudfront.net/${getCompanyId()}.jpg?v=${getLogoVersion() || ''}`
    : '';

export const getLogoSize = () =>
  doesLogoExists() ? { height: amalgamGetLogoHeight(), width: amalgamGetLogoWidth() } : {};

export const doesLogoExists = () => amalgamDoesLogoExists();

export const getAltLogoPath = () =>
  doesAltLogoExists()
    ? `https://d1h96izmtdkx5o.cloudfront.net/${getCompanyId()}_alt.jpg?v=${getAltLogoVersion() ||
        ''}`
    : '';

export const doesAltLogoExists = () => amalgamDoesAltLogoExists();
